import { LmgService } from "../resource";

const CommModule = {
  namespaced: true,
  state: {
    datas: [],
    datas_extra: [],
    data: {},
  },
  mutations: {
    SET_DATAS_EXTRA(state, payload) {
      state.datas_extra = payload;
    },
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.CommCreate(payload);
    },
    createExtraData({ commit, state }, payload) {
      return LmgService.CommExtraCreate(payload);
    },
    updateData({ commit, state }, payload) {
      return LmgService.CommUpdate(payload.ID,payload);
    },
    updateExtraDataByPerson({ commit, state }, payload) {
      return LmgService.CommUpdateExtraDataByPerson(payload);
    },
    deleteData({ commit, state }, payload) {
      return LmgService.CommDelete(payload.ID,payload);
    },
    deleteExtraData({ commit, state }, payload) {
      return LmgService.CommExtraDelete(payload.ID,payload);
    },
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.CommList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
    async listExtraData({ commit, state },payload) {
      try {
        const data = await LmgService.CommExtraList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS_EXTRA", []);
        } else {
          commit("SET_DATAS_EXTRA", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS_EXTRA", []);
      }
    },

    async listExtraDataByPerson({ commit, state },payload) {
      try {
        commit("SET_DATAS_EXTRA", []);
        const data = await LmgService.CommExtraListByPerson(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS_EXTRA", []);
        } else {
          commit("SET_DATAS_EXTRA", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS_EXTRA", []);
      }
    },

    
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getDataExtra(state) {
      return state.datas_extra;
    },
    getDataWithAll(state) {
      return [{ID:0,Name: "ทั้งหมด"} , ...state.datas];
    },
    
  }
};

export default CommModule;
